import { render } from "./DynamicMultiSelect.vue?vue&type=template&id=e828b2a4&ts=true"
import script from "./DynamicMultiSelect.vue?vue&type=script&lang=ts"
export * from "./DynamicMultiSelect.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicMultiSelect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e828b2a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e828b2a4', __exports__)) {
    api.reload('e828b2a4', __exports__)
  }
  
  module.hot.accept("./DynamicMultiSelect.vue?vue&type=template&id=e828b2a4&ts=true", () => {
    api.rerender('e828b2a4', render)
  })

}


export default __exports__